/** Playlists page with this playlist's drawer open. */
export function playlistPath(playlistId: string): string {
  return `/playlists?${new URLSearchParams({ playlistId }).toString()}`;
}
